(() => {
  const ROOT_SELECTOR = '#main-collection-filters';
  let scheduled = false;

  const numericCount = (item) => {
    const dataCount = item.getAttribute('data-aam-facet-count');
    if (dataCount !== null && dataCount.trim() !== '') {
      const value = Number.parseInt(dataCount, 10);
      if (Number.isFinite(value)) return value;
    }

    const text = item.querySelector('.facet-checkbox__text')?.textContent || item.textContent || '';
    const match = text.match(/\((\d+)\)\s*$/);
    return match ? Number.parseInt(match[1], 10) : null;
  };

  const setClass = (element, className, enabled) => {
    if (!element) return;
    const has = element.classList.contains(className);
    if (enabled && !has) element.classList.add(className);
    if (!enabled && has) element.classList.remove(className);
  };

  const cleanFacetItems = (root) => {
    root.querySelectorAll('.facets__item, .mobile-facets__item').forEach((item) => {
      const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
      const active = Boolean(input?.checked);
      const disabled = Boolean(input?.disabled);
      const count = numericCount(item);
      const hide = !active && (disabled || count === 0);
      setClass(item, 'aam-facet-zero-hidden', hide);
      item.setAttribute('aria-hidden', hide ? 'true' : 'false');
    });
  };

  const cleanEmptyGroups = (root) => {
    root.querySelectorAll('.facets__disclosure.js-filter').forEach((details) => {
      const items = [...details.querySelectorAll('.facets__item')];
      if (!items.length) return;
      const visible = items.some((item) => !item.classList.contains('aam-facet-zero-hidden'));
      setClass(details, 'aam-facet-empty-filter', !visible);
      if (!visible) details.removeAttribute('open');
    });

    root.querySelectorAll('.mobile-facets__details.js-filter').forEach((details) => {
      const items = [...details.querySelectorAll('.mobile-facets__item')];
      if (!items.length) return;
      const visible = items.some((item) => !item.classList.contains('aam-facet-zero-hidden'));
      setClass(details, 'aam-facet-empty-filter', !visible);
      if (!visible) details.removeAttribute('open');
    });
  };

  const cleanShowMore = (root) => {
    root.querySelectorAll('.parent-display').forEach((display) => {
      const visibleItems = [...display.querySelectorAll('.facets__item')]
        .filter((item) => !item.classList.contains('aam-facet-zero-hidden'));
      const button = display.querySelector('show-more-button');
      if (button) button.hidden = visibleItems.length <= 10;
    });
  };

  const clean = () => {
    scheduled = false;
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    cleanFacetItems(root);
    cleanEmptyGroups(root);
    cleanShowMore(root);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(clean);
  };

  const init = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    clean();
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    root.addEventListener('change', schedule, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
})();
